import { render, staticRenderFns } from "./GuestConsumptionSection.vue?vue&type=template&id=0b48412a"
import script from "./GuestConsumptionSection.vue?vue&type=script&lang=js"
export * from "./GuestConsumptionSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports